import * as constants from './constants';
import http from '../../../utils/request';
import aboutMeJson from '../../../statics/api/about-me.json';

const getAboutData = (result) => ({
  type: constants.GET_ABOUT_DATA,
  contentCta: result.contentCta,
  // hoverCard: result.hoverCard,
  hoverCardPlus: result.hoverCardPlus
});

const getAboutMeData = (result) => ({
  type: constants.GET_ABOUT_ME_DATA,
  hoverCard: result.doctor,
  head: result.head
});

export const fetchAboutPageData = () => {
  return (dispatch) => {
    const result = aboutMeJson.data
    dispatch(getAboutData(result));
  }
}

export const fetchAboutMeData = () => {
  return (dispatch) => {
    http('post','/achieve/circle/about').then((res) => {
      const result = res.data;
      // console.log('result',result)
      dispatch(getAboutMeData(result));
    })
  }
}